// extracted by mini-css-extract-plugin
export default {"field":"DetailsCollaborators_field__SEgdZ","cards":"DetailsCollaborators_cards__gv2lF","content":"DetailsCollaborators_content__lmVXo"};